import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebaseConfig';

const functions = getFunctions(app, 'europe-west1');

/** Changes to who is in a household, made on the server, which alone can change it for everyone. */
export class MembershipService {
  private removeFn = httpsCallable<{ householdId: string; memberId: string }, { success: boolean }>(
    functions,
    'household-removeMember',
  );

  // The shapes of SetChildRequest and SetChildResponse in shared/src, which the app doesn't import.
  private setChildFn = httpsCallable<{ householdId: string; memberId: string; isChild: boolean }, { success: boolean }>(
    functions,
    'household-setChild',
  );

  async removeMember(householdId: string, memberId: string): Promise<void> {
    await this.removeFn({ householdId, memberId });
  }

  /** Makes a member one of the household's children, or not (docs/plans/children.md). */
  async setChild(householdId: string, memberId: string, isChild: boolean): Promise<void> {
    await this.setChildFn({ householdId, memberId, isChild });
  }
}

export const membershipService = new MembershipService();
